export const iconFontAwesomeMedicalHealthSmoking = (
	<i className="fa-solid fa-smoking"></i>
);
